module.exports = __webpack_public_path__ + "img/lr1-mc-rrl1.a2314d12.gif";